import React, { useRef, useState } from "react";
import api, { extractErrorMessage } from "@/lib/api";
import { ImagePlus, Trash2, Image as ImageIcon } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const CompetitionLogoField = ({ competitionId, logoUrl, onChanged }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    setError("");
    try {
      const fd = new FormData();
      fd.append("file", file);
      await api.post(`/competitions/${competitionId}/logo`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      await onChanged();
    } catch (e) {
      setError(extractErrorMessage(e));
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = async () => {
    if (!window.confirm("Remover a logomarca do campeonato? Os PDFs voltam a mostrar só o nome.")) return;
    setBusy(true);
    try {
      await api.delete(`/competitions/${competitionId}/logo`);
      await onChanged();
    } catch (e) {
      setError(extractErrorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border border-white/10 p-3 space-y-2" data-testid="comp-logo-box">
      <label className="overline block flex items-center gap-2">
        <ImageIcon size={12} /> Logomarca do campeonato (PDFs)
      </label>
      {!competitionId ? (
        <div className="text-[11px] text-[var(--text-secondary)]" data-testid="comp-logo-hint-create">
          Salve o campeonato primeiro; depois envie a logo em "Editar".
        </div>
      ) : (
        <div className="flex items-center gap-3">
          <div className="w-24 h-16 bg-white/5 border border-white/10 flex items-center justify-center overflow-hidden shrink-0">
            {logoUrl ? (
              <img
                data-testid="comp-logo-preview"
                src={`${BACKEND}/api/public/files/${logoUrl}`}
                alt="Logo do campeonato"
                className="max-w-full max-h-full object-contain"
              />
            ) : (
              <span className="text-[10px] text-[var(--text-secondary)]">sem logo</span>
            )}
          </div>
          <div className="flex-1 space-y-1">
            <input
              ref={inputRef}
              data-testid="comp-logo-input"
              type="file"
              accept="image/png,image/jpeg"
              className="hidden"
              onChange={(e) => upload(e.target.files?.[0])}
            />
            <div className="flex gap-2 flex-wrap">
              <button
                type="button"
                data-testid="comp-logo-upload"
                className="btn-ghost !py-1 !text-xs inline-flex items-center gap-1"
                disabled={busy}
                onClick={() => inputRef.current?.click()}
              >
                <ImagePlus size={12} /> {busy ? "Enviando..." : logoUrl ? "Trocar logo" : "Enviar logo"}
              </button>
              {logoUrl && (
                <button
                  type="button"
                  data-testid="comp-logo-remove"
                  className="btn-ghost !py-1 !text-xs !text-[#C9A84C] inline-flex items-center gap-1"
                  disabled={busy}
                  onClick={remove}
                >
                  <Trash2 size={12} /> Remover
                </button>
              )}
            </div>
            <div className="text-[11px] text-[var(--text-secondary)]">
              PNG ou JPG até 3 MB. Aparece centralizada no cabeçalho de todos os PDFs; sem logo, o nome do campeonato fica em destaque.
            </div>
            {error && <div className="text-[11px] text-[#C9A84C]" data-testid="comp-logo-error">{error}</div>}
          </div>
        </div>
      )}
    </div>
  );
};
